// api.service.ts
import { Injectable } from '@angular/core';
import { fetchAuthSession } from 'aws-amplify/auth';
import { ApiClient } from './api-types/api-client';
import { ApiInput, ApiOutput, ApiName } from './api-types/api-schema';

export const API_ENDPOINT = `https://api.weapps.net/`;

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private client: ApiClient;

  constructor() {
    console.log(`Using API endpoint: ${API_ENDPOINT}`);
    this.client = new ApiClient(API_ENDPOINT, this.getJwtToken);
  }

  call<K extends ApiName>(
    name: K,
    input: ApiInput<K>
  ): Promise<ApiOutput<K>> {
    return this.client.callEndpoint(name, input);
  }

  callSpecific<K extends ApiName>(
    name: K,
    input: ApiInput<K>
  ): Promise<ApiOutput<K>> {
    return this.client.callEndpoint(name, input);
  }

  private async getJwtToken(): Promise<string> {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() || '';
  }
}
